import Ajv from "ajv";
import { DriverPlannings } from "./driverPlanningsApi";
import { getStartTimeAndEndTimeFromExcel } from "./lib";

export type InputLine = {
  "Code salarié": string;
  "Date début intervention": string;
  "Heure fin intervention": string;
  "Heure début intervention": string;
  Kilomètres: string;
  Commune?: string;
  "Nom usuel du membre"?: string;
  Prénom?: string;
  Commune_1?: string;
  "Nom Rubrique"?: string;
};

const schema = {
  type: "array",
  items: {
    type: "object",
    properties: {
      "Code salarié": {
        type: "string",
      },
      "Date début intervention": {
        type: "string",
        pattern: "^[0-9][0-9]?/[0-9][0-9]?/[0-9]{2,4}$",
      },
      "Heure début intervention": {
        type: "string",
        pattern: "^[0-9]{4}$",
      },
      "Heure fin intervention": {
        type: "string",
        pattern: "^[0-9]{4}$",
      },
      Kilomètres: {
        type: "string",
        pattern: "^[0-9]+\\.?[0-9]*$",
      },
      Commune: {
        type: "string",
      },
      "Nom usuel du membre": {
        type: "string",
      },
      Prénom: {
        type: "string",
      },
      Commune_1: {
        type: "string",
      },
      "Nom Rubrique": {
        type: "string",
      },
    },
    required: [
      "Code salarié",
      "Date début intervention",
      "Heure début intervention",
      "Heure fin intervention",
      "Kilomètres",
    ],
  },
};

const ajv = new Ajv({ formats: { date: "date" } });

export const validate = ajv.compile(schema);

export const parseLine = (line: InputLine): DriverPlannings => {
  const dateSplitted = line["Date début intervention"].split("/");
  let day: string;
  let month: string;
  let year: string;

  if (dateSplitted[2].length === 2) {
    [month, day, year] = dateSplitted;
    year = `20${year}`;
  } else {
    [day, month, year] = dateSplitted;
  }

  const { startTime, endTime } = getStartTimeAndEndTimeFromExcel(
    year,
    month,
    day,
    {
      hours: parseInt(line["Heure début intervention"].slice(0, 2)),
      minutes: parseInt(line["Heure début intervention"].slice(2, 4)),
    },
    {
      hours: parseInt(line["Heure fin intervention"].slice(0, 2)),
      minutes: parseInt(line["Heure fin intervention"].slice(2, 4)),
    },
  );
  const hasKmClient = Boolean(
    line["Nom Rubrique"] &&
      line["Nom Rubrique"].replace(/[^a-zA-Z0-9]/g, "").toLowerCase() ===
        "kmsclient",
  );

  return {
    driverIdNumber: line["Code salarié"],
    expectedMileage: parseFloat(line["Kilomètres"]),
    startTime,
    endTime,
    driverCity: line["Commune"] ?? null,
    clientName:
      line["Nom usuel du membre"] && line["Prénom"]
        ? `${line["Prénom"]} ${line["Nom usuel du membre"]}`
        : null,
    clientCity: line["Commune_1"] ?? null,
    hasKmClient,
    activityType: line["Nom Rubrique"] ?? null,
  };
};
